import { Paper, Stack, Table, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { takeFromStart } from '@weft/utils';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useGetUsageByMeter } from 'apps/app/src/hooks/requests/use-get-usage-by-meter';
import dayjs from 'dayjs';
import { DataDashboardLoadingSkeleton } from '../DataDashboardLoadingSkeleton';
import { DataDashboardTableHeaderCell } from '../DataDashboardTableHeaderCell';
import { UsageMyMeterChart } from './usage-by-meter-chart';
import { getUsageByMeterBaseColorByIndex } from './usage-by-meter-section-utils/get-usage-by-meter-base-color-by-index';
import { UsageByMeterTableRow } from './usage-by-meter-table-row';

const DEFAULT_TABLE_ROW_COUNT = 5;

const UsageByMeterSection: React.FC = () => {
  const vyTheme = useTheme();
  const { data: { usageByMeter: usageByMeterResponse } } = useGetUsageByMeter();
  const usageByMeter = takeFromStart(usageByMeterResponse, DEFAULT_TABLE_ROW_COUNT);
  const year = dayjs().year();

  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: 3,
      })}
    >
      <Typography variant='h6'>Usage by Product</Typography>
      <Typography
        variant='body2'
        color={theme => theme.palette.text.secondary}
      >
        {`YTD ${year}`}
      </Typography>
      <Stack
        direction='row'
        alignItems="center"
        justifyContent='space-between'
        marginTop={2}
        gap={4}
      >
        <UsageMyMeterChart usageByMeter={usageByMeter}/>
        <Table
          size='small'
        >
          <TableHead>
            <TableRow>
              <DataDashboardTableHeaderCell
                text='Name'
                align='left'
              />
              <DataDashboardTableHeaderCell
                text='Total Sum'
                align='right'
              />
            </TableRow>
          </TableHead>
          {usageByMeter.map((meterUsage, index) => 
            (
              <UsageByMeterTableRow
                total={meterUsage.usageAmount}
                name={meterUsage.meterName}
                color={getUsageByMeterBaseColorByIndex(index, vyTheme).light}
              />
            ))}
        </Table>
      </Stack>
    </Paper>
  );
};

const UsageByMeterSectionWithSuspense = withSuspenseBoundary(UsageByMeterSection, { suspenseProps: { fallback: <DataDashboardLoadingSkeleton/> } });

export { UsageByMeterSectionWithSuspense as UsageByMeterSection };